import { useState } from 'react'

import { DESCRIPTION_MAX_CHARS, INITIAL_FORM } from '../constants/uploadResource.constants'
import { FormErrors, FormValues } from '../types/uploadResource.types'
import { validateForm } from '../utils/uploadResource.helpers'

export const useUploadResourceForm = (): {
  form: FormValues
  errors: FormErrors
  handleChange: <K extends keyof FormValues>(key: K, value: FormValues[K]) => void
  handleDescriptionChange: (value: string) => void
  handleGlobalToggle: () => void
  validateBeforeSubmit: () => FormErrors
  hasAnyValue: boolean
} => {
  const [form, setForm] = useState<FormValues>(INITIAL_FORM)
  const [errors, setErrors] = useState<FormErrors>({})
  const [submitted, setSubmitted] = useState(false)

  const handleChange = <K extends keyof FormValues>(key: K, value: FormValues[K]): void => {
    const updated = { ...form, [key]: value }
    setForm(updated)

    if (submitted) {
      setErrors(validateForm(updated))
    }
  }

  const handleDescriptionChange = (value: string): void => {
    if (value.length > DESCRIPTION_MAX_CHARS) return
    handleChange('description', value)
  }

  const handleGlobalToggle = (): void => {
    const updated: FormValues = {
      ...form,
      isGlobal: !form.isGlobal,
      ou: '',
    }

    setForm(updated)

    if (submitted) {
      setErrors(validateForm(updated))
    }
  }

  const validateBeforeSubmit = (): FormErrors => {
    setSubmitted(true)
    const errs = validateForm(form)
    setErrors(errs)
    return errs
  }

  const hasAnyValue =
    form.title.trim() !== '' ||
    form.link.trim() !== '' ||
    form.description.trim() !== '' ||
    form.skills.length > 0 ||
    form.resourceType !== '' ||
    form.isGlobal ||
    form.ou !== ''

  return {
    form,
    errors,
    handleChange,
    handleDescriptionChange,
    handleGlobalToggle,
    validateBeforeSubmit,
    hasAnyValue,
  }
}
